export default {
    GET_SLOTS_REQUEST: 'GET_SLOTS_REQUEST',
    GET_SLOTS_SUCCESS: 'GET_SLOTS_SUCCESS',
    GET_SLOTS_FAILURE: 'GET_SLOTS_FAILURE',

    GET_DATE_SLOTS_REQUEST: 'GET_DATE_SLOTS_REQUEST',
    GET_DATE_SLOTS_SUCCESS: 'GET_DATE_SLOTS_SUCCESS',
    GET_DATE_SLOTS_FAILURE: 'GET_DATE_SLOTS_FAILURE',

    GET_SLOTS_SILENTLY_REQUEST: 'GET_SLOTS_SILENTLY_REQUEST',
    GET_SLOTS_SILENTLY_SUCCESS: 'GET_SLOTS_SILENTLY_SUCCESS',
    GET_SLOTS_SILENTLY_FAILURE: 'GET_SLOTS_SILENTLY_FAILURE',

    RESET_SLOTS_STATE: 'RESET_SLOTS_STATE'
};
